import Glide from '@glidejs/glide'

// Wait for the dom to load. Then, load the carousel
document.addEventListener("DOMContentLoaded", function() {
   
    // Get the carousel element
    const carousel = document.querySelector(".profile-block");

    // If the carousel exists, run the carousel code
    if (carousel) {
        // Tweak styles
        carousel.style.overflow = "hidden";

        // Add arrows
        carousel.insertAdjacentHTML(
        "beforeend",
        `<div class="glide__arrows" data-glide-el="controls">
            <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fa-solid fa-chevron-left"></i></button>
            <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fa-solid fa-chevron-right"></i></button>
        </div>`
        );

        // Mount carousel
        let quarter = 0;
        if (window.innerWidth < 800) {
            quarter = window.innerWidth / 4;
        } else {
            quarter = 200;
        }

        let profileBlockCarousel = new Glide(".profile-block", {
            type: "carousel",
            perView: 1,
            autoplay: false,
            peek: quarter
        }).mount();

        // Change the peek depending on the window size
        window.addEventListener('resize', function() {
            if (window.innerWidth < 800) {
                quarter = window.innerWidth / 4;
            } else {
                quarter = 200;
            }
            profileBlockCarousel.update({
                peek: quarter
            })
        })

        const glideArrows = document.querySelectorAll(".glide__arrow");

        // Add an event listener that will update the URL when the arrow is clicked
        glideArrows.forEach(function(arrow) {
            arrow.addEventListener("click", function(e) {
                // Wait 1 second before changing the url
                setTimeout(updateURL, 1000)
            });
        });

        // FUNCTIONS

        // Adjust the height of the .profile-block element to the height of the current slide
        const adjustHeight = function() {
            // Get the height of the .profile-block__slide__inner element for the current slide
            const minSlideHeight = document.querySelector(".glide__slide--active .profile-block__slide__inner").offsetHeight;
            const slideHeight = minSlideHeight + 100;
            // Set the height of the .profile-block element to the height of the current slide
            document.querySelector(".profile-block").style.height = slideHeight + 'px';
        }

        adjustHeight();

        // Update the url
        const updateURL = function() {
             // Get the current slide
            const currentSlide = document.querySelector(".glide__slide--active");

            // Get the data-slug atribute for the current slide
            const slug = currentSlide.dataset.slug;
        
            // Get the current url and remove the last slug
            const currentUrl = window.location.href;
            let splitUrl = currentUrl.split('/');
            // Get rid of the last space
            splitUrl.pop();
            // Get the last slug
            splitUrl.pop();
            // Get the data-category element
            const urlWithoutLastSlug = splitUrl.join('/');

            // Change the url to the slug by deleting the current url and adding the slug
            history.pushState({}, null, urlWithoutLastSlug + '/' + slug + '/');

            // Get the title of the current slide
            const slideTitle = document.querySelector(".glide__slide--active .profile-block__slide__title").innerHTML;

            // Change the page's title to the slide title
            document.title = slideTitle;

            // // Find the breadcrumbs element
            // const breadcrumbs = document.querySelector(".breadcrumbs");

            // // Get the last breadcrumb
            // const lastBreadcrumb = breadcrumbs.lastElementChild;

            // // Change the last breadcrumb's text to the slide title
            // lastBreadcrumb.innerHTML = slideTitle;
            
            // // Change the last breadcrumb's href to the slug
            // lastBreadcrumb.setAttribute("href", slug);


            // Adjust the height of the .profile-block element to the height of the current slide
            adjustHeight();
        }

    }
})


